export default __webpack_public_path__ + "static/logo_awumba_long-93ba4ae3ffdc9c6c443de03d4b2eadc9.png";